import React from 'react';
import { MailIcon, PhoneIcon, CalendarIcon, FolderIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-12 bg-white" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="lg:text-center mb-12" data-id="element-48">
          <h2 className="text-base text-green-600 font-semibold tracking-wide uppercase" data-id="element-49">
            ABOUT ME
          </h2>
          <p className="mt-2 text-4xl font-bold mb-2 text-[#2c3e50]" data-id="element-50">
            The Person Behind The Words
          </p>
          <p className="text-xl text-gray-600 mb-6" data-id="element-51">
            - Founder of Mayhave Copy
          </p>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-52">
          <div className="w-full lg:w-1/2" data-id="element-53">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-54">
              Hey, I'm James Walker
            </h3>
            <p className="text-lg text-gray-600 mb-4" data-id="element-55">
              I fix copy that doesn't convert, and I write copy that connects
              with real people.
            </p>
            <p className="text-lg text-gray-600 mb-4" data-id="element-56">
              <strong data-id="element-57">Here's my belief:</strong> Good messaging isn't about
              sounding impressive. It's about being clear, helpful, and genuine.
            </p>
            <p className="text-lg text-gray-600 mb-4" data-id="element-58">
              I work closely with each client to understand their brand voice
              and their audience's needs. Then I write strategic copy that
              bridges that gap.
            </p>
            <p className="text-lg text-gray-600 mb-4" data-id="element-59">
              <strong data-id="element-60">My focus?</strong> Creating messages that feel authentic
              instead of artificial. Human instead of corporate. Helpful instead
              of pushy.
            </p>
            <p className="text-lg text-gray-600 mb-4" data-id="element-61">
              Because when your copy finally speaks your audience's language,
              everything else becomes easier.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-62">
              <strong data-id="element-63">Sound familiar?</strong> Websites that don't convert.
              Emails that get ignored. Marketing that feels like shouting into
              the void. I help businesses fix exactly these problems. Let's talk
              about turning your words into revenue.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-64">
              <a href="https://calendly.com/mayhave/30min" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-3 border border-transparent text-lg font-medium rounded-full shadow-sm text-white bg-green-600 hover:bg-green-700 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-65">
                <CalendarIcon className="mr-2 h-5 w-5" data-id="element-66" />
                Book Your Strategy Call
              </a>
              <a href="/portfolio" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-3 border border-transparent text-lg font-medium rounded-full shadow-sm text-green-700 bg-green-100 hover:bg-green-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg" data-id="element-67">
                <FolderIcon className="mr-2 h-5 w-5" data-id="element-68" />
                See My Work
              </a>
            </div>
          </div>
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-id="element-69">
            <div className="rounded-lg overflow-hidden shadow-xl max-w-md" data-id="element-70">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dij11mgRd4qZJznYkJmeP8/Facetune_27-07-2025-22-52-12.jpg" alt="Professional headshot" className="w-full h-auto" data-id="element-71" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};